import { formatDateWithTime } from "src/utils/dates";
import LookupStatusIndicator, { LookupStatus } from "src/components/common/LookupStatusIndicator";
import { SavedSearchLookupStatusCode } from "../../constants";

interface SavedSearchCardHeaderProps {
  name: string;
  numProperties: number;
  createdAt: string;
  isExpanded?: boolean;
  lookupStatusCode?: SavedSearchLookupStatusCode | string;
  lookupStatus?: LookupStatus;
  lookupStatusLabel?: string;
}
export const SavedSearchCardHeader = ({
  name,
  numProperties,
  createdAt,
  isExpanded = false,
  lookupStatusCode,
  lookupStatus,
  lookupStatusLabel,
}: SavedSearchCardHeaderProps) => {

  return (
    <div className="w-full">
      <div className="flex flex-col gap-1 relative top-[-3px]">
        <div className="flex flex-row justify-between items-center">
          <h2
            className={`text-base leading-none font-medium text-ellipsis overflow-hidden whitespace-nowrap max-w-[185px] ${
              isExpanded ? "text-orange-500" : "text-gray-700"
            }`}
          >
            {name}
          </h2>
          <p className="font-medium text-gray-700 whitespace-nowrap ml-2">
            <span className="font-bold" >{numProperties}</span> properties
          </p>
        </div>
        <div className="flex flex-row justify-between items-center">
          <p className="text-gray-500 text-xs">
            Created {formatDateWithTime(createdAt)}
          </p>
          {lookupStatusCode &&
           lookupStatus&& (
            <div className="ml-2">
              <LookupStatusIndicator status={lookupStatus} label={lookupStatusLabel} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
